import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
// 1. IMPORTATION DU NOUVEAU COMPOSANT
import DownloadKpsCreator from '../../../components/ui/DownloadKpsCreator'; 

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    company: [
      { name: 'À Propos', path: '/about-trust-center' },
      { name: 'Notre Équipe', path: '/about-trust-center' },
      { name: 'Carrières', path: '/about-trust-center' },
      { name: 'Presse', path: '/about-trust-center' }
    ],
    services: [
      { name: 'Recherche de Propriétés', path: '/property-search-listings' },
      { name: 'Guide des Communes', path: '/commune-explorer' },
      { name: 'Services Juridiques', path: '/legal-services-center' },
      { name: 'Évaluation Immobilière', path: '/property-search-listings' }
    ],
    support: [
      { name: "Centre d'Aide", path: '/about-trust-center' },
      { name: 'Contact', path: '/about-trust-center' },
      { name: 'FAQ', path: '/about-trust-center' },
      { name: 'Signaler un Problème', path: '/about-trust-center' }
    ],
    legal: [
      { name: "Conditions d'Utilisation", path: '/legal-compliance-footer' },
      { name: 'Politique de Confidentialité', path: '/legal-compliance-footer' },
      { name: 'Mentions Légales', path: '/legal-compliance-footer' },
      { name: 'Cookies', path: '/legal-compliance-footer' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: 'Facebook', url: 'https://web.facebook.com/' },
    { name: 'Twitter', icon: 'Twitter', url: 'https://x.com/KapitalStates' },
    { name: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/kapitalstates/' },
    { name: 'LinkedIn', icon: 'Linkedin', url: 'https://www.linkedin.com/in/kapital-states-14751a386/' },
    { name: 'YouTube', icon: 'Youtube', url: '#' }
  ];

  const handleNewsletterSubmit = (e) => {
    e?.preventDefault();
    // Logique d'inscription ici
  };

  return (
    <footer className="bg-[#0A0A0A] text-white relative z-10 border-t border-white/5">
      {/* 
        ================================================================
        SECTION 1 : BANNIÈRE DE TÉLÉCHARGEMENT PREMIUM (Style Apple)
        ================================================================
      */}
      <div className="border-b border-white/5 bg-gradient-to-b from-white/[0.02] to-transparent">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 bg-[#111111] rounded-2xl p-8 border border-white/10 shadow-2xl relative overflow-hidden group">
            
            {/* Effet de lumière subtil au survol (Glow) */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-purple-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />

            <div className="flex items-center gap-5 z-10">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg shadow-blue-500/20">
                <Icon name="Monitor" size={26} color="white" strokeWidth={1.5} />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-white text-xl tracking-tight mb-1">
                  KPS Creator Studio
                </h3>
                <p className="text-white/50 text-sm font-body max-w-md leading-relaxed">
                  Gérez et sécurisez vos transactions de A à Z avec notre outil avancé. Téléchargez la dernière version pour une expérience optimale.
                </p>
              </div>
            </div>
            
            {/* 
              2. INTÉGRATION DU BOUTON DYNAMIQUE
              (Ce composant se charge maintenant de lire la base de données et de créer le bon lien) 
            */}
            <div className="z-10">
              <DownloadKpsCreator />
            </div>

          </div>
        </div>
      </div>

      {/* 
        ================================================================
        SECTION 2 : LIENS DU FOOTER (Épuré et structuré)
        ================================================================
      */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">

          {/* Colonne 1 : Marque & Newsletter (Prend plus de place) */}
          <div className="lg:col-span-4 pr-0 lg:pr-8">
            <Link to="/homepage" className="flex items-center gap-3 mb-6 group inline-flex">
              <div className="w-9 h-9 bg-brand-gold rounded-lg flex items-center justify-center shadow-lg shadow-brand-gold/20">
                <Icon name="Building2" size={18} color="#0A0A0A" strokeWidth={2} />
              </div>
              <div className="flex flex-col">
                <span className="font-heading font-bold text-lg text-white tracking-tight leading-none mb-1">Kapital States</span>
                <span className="text-[11px] text-brand-gold font-medium uppercase tracking-widest leading-none">Elevating Real Estate</span>
              </div>
            </Link>

            <p className="text-white/50 font-body text-sm mb-8 leading-relaxed">
              La plateforme immobilière premium de Côte d'Ivoire. Nous connectons l'écosystème immobilier avec des outils de confiance absolue.
            </p>

            <div className="mb-8">
              <form onSubmit={handleNewsletterSubmit} className="flex gap-2">
                <Input
                  type="email"
                  placeholder="Votre adresse email"
                  className="bg-white/5 border-white/10 text-white placeholder:text-white/30 focus-visible:ring-brand-gold h-10 rounded-lg text-sm" 
                />
                <button
                  type="submit"
                  className="h-10 px-4 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors border border-white/5 flex items-center justify-center flex-shrink-0"
                  aria-label="S'abonner"
                >
                  <Icon name="ArrowRight" size={16} />
                </button>
              </form>
            </div>
          </div>

          {/* Colonne 2 : Liens de navigation */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {[
                { title: 'Entreprise', links: footerLinks?.company },
                { title: 'Services', links: footerLinks?.services },
                { title: 'Support', links: footerLinks?.support },
                { title: 'Légal', links: footerLinks?.legal }
              ]?.map((section) => (
                <div key={section?.title}>
                  <h4 className="font-heading font-semibold text-white tracking-wide text-sm mb-5">{section?.title}</h4>
                  <ul className="space-y-3.5">
                    {section?.links?.map((link) => (
                      <li key={link?.name}>
                        <Link
                          to={link?.path}
                          className="text-white/40 hover:text-white transition-colors duration-200 text-[13px] font-body"
                        >
                          {link?.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 
        ================================================================
        SECTION 3 : BASE DU FOOTER (Copyright & Réseaux)
        ================================================================
      */}
      <div className="border-t border-white/5 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          
          <div className="flex items-center gap-6">
            <p className="text-white/30 text-xs font-body">
              © {currentYear} Kapital States. Tous droits réservés.
            </p>
            <div className="hidden md:flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-20"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
              </span>
              <span className="text-white/30 text-xs font-body">Systèmes opérationnels</span>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {socialLinks?.map((social) => (
              <a
                key={social?.name}
                href={social?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/30 hover:text-white transition-colors duration-200"
                aria-label={social?.name}
              >
                <Icon name={social?.icon} size={16} />
              </a>
            ))}
          </div>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;